import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useMenuReducer = () =>
  useSelector((state: ApplicationState) => state.menu);
